import React from 'react';

import { ApolloError } from '@apollo/client';



export type FnHandleErrorMessage = (message: string) => void;

let __fnHandleErrorMessage: FnHandleErrorMessage = message => {
  alert(message);
}



export interface IConfig {
  fnHandleErrorMessage?: FnHandleErrorMessage;
}

export function init(config: IConfig) {
  if (config.fnHandleErrorMessage) {
    __fnHandleErrorMessage = config.fnHandleErrorMessage;
  }
}



export interface IHasMessage {
  message: string;
}



export function removeGraphqlErrorPrefix(errorMessage: string) {
  return errorMessage.replace(/^GraphQL error: /, '');
}



export async function errorWrap<T>(fn: () => Promise<T>, errorCode2Message?: Record<string, string>, fnHandleErrorMessage?: FnHandleErrorMessage) {
  const definedFnHandleErrorMessage = fnHandleErrorMessage || __fnHandleErrorMessage;

  try {
    return await fn();

  } catch (err: any) {
    console.error(err);
    if (errorCode2Message) {
      const errorCode = removeGraphqlErrorPrefix(err.message);
      const message = errorCode2Message[errorCode];
      if (message) {
        definedFnHandleErrorMessage(message);
      } else {
        definedFnHandleErrorMessage(err.message);
      }

    } else {
      definedFnHandleErrorMessage(err.message);
    }
  }
}



export function useWrapQueryTuple<TTuple extends {error?: ApolloError;}>(tuple: TTuple) {
  React.useEffect(
    () => {
      if (tuple.error) {
        alert(tuple.error);
      }
    },
    [tuple.error]
  );

  return tuple;
}



export function useWrapLazyQueryOrMutationTuple<TTuple extends {error?: ApolloError;}, TFnQuery>([fnQuery, tuple]: readonly [TFnQuery, TTuple]) {
  const wrappedTuple = useWrapQueryTuple(tuple);
  return [fnQuery, wrappedTuple] as const;
}
